import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { useScript } from '../utils/network/useScript';
import { Spinner } from '../Spinner';
import { Bodytext } from '../Typography';
import { useUrlResolver } from './useUrlResolver';
var STATES;

(function (STATES) {
  STATES[STATES["loading"] = 0] = "loading";
  STATES[STATES["success"] = 1] = "success";
  STATES[STATES["error"] = 2] = "error";
})(STATES || (STATES = {}));

var ErrorComponent = function ErrorComponent() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/accessible-emoji
    React.createElement(Bodytext, null, "Unable to load micro frontend \uD83D\uDE41")
  );
};

var AsyncComponent = function AsyncComponent(_ref) {
  var componentName = _ref.componentName,
      _ref$componentProps = _ref.componentProps,
      componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
      isDevMode = _ref.isDevMode,
      loader = _ref.loader,
      projectName = _ref.projectName,
      url = _ref.url,
      className = _ref.className,
      _ref$showLoader = _ref.showLoader,
      showLoader = _ref$showLoader === void 0 ? true : _ref$showLoader;
  var client = useApolloClient();
  var resolvedUrl = useUrlResolver(url, projectName, isDevMode);

  var _useState = useState(STATES.loading),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useScript = useScript(resolvedUrl),
      _useScript2 = _slicedToArray(_useScript, 2),
      loaded = _useScript2[0],
      error = _useScript2[1];

  var Component = state === STATES.success ? window.acorns[projectName][componentName] : null;
  var LoadingComponent = loader !== null && loader !== void 0 ? loader : Spinner;
  useEffect(function () {
    var nextState = STATES.loading;

    if (!error && loaded) {
      nextState = STATES.success;
    }

    if (error) {
      nextState = STATES.error;
    }

    setState(nextState);
  }, [loaded, error]);

  if (state === STATES.success) {
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: className,
      client: client
    }, componentProps));
  } else if (state === STATES.error) {
    return /*#__PURE__*/React.createElement(ErrorComponent, {
      className: className
    });
  } else if (showLoader) {
    return /*#__PURE__*/React.createElement(LoadingComponent, {
      className: className
    });
  } else {
    return null;
  }
};

export { AsyncComponent };